import { FC, useEffect, useState } from 'react';

import { BaseCustomComponentVideo } from '../add-element';

import * as Styled from './menu.styles';

type ItemList = {
  id: string;
  label: string;
  selected?: boolean;
};
type State = {
  type: string | null;
  isVisible: boolean;
  list: ItemList[];
  action?: (item: ItemList, index: number) => void;
};

type Props = BaseCustomComponentVideo & {
  callback: (
    callback: (
      type: string,
      list: ItemList[],
      action: (item: ItemList, index: number) => void
    ) => void
  ) => void;
};
export const Menu: FC<Props> = ({ player, callback }) => {
  const [state, setState] = useState<State>({
    type: null,
    isVisible: false,
    list: [],
    action: undefined,
  });

  player.toggleClass('xing-vjs-menu-visible', state.isVisible);

  useEffect(() => {
    callback(setMenu);
  }, []);

  const setMenu = (
    type: string,
    list: ItemList[],
    action: (item: ItemList, index: number) => void
  ): void => {
    const isVisible = state.type === type ? !state.isVisible : true;

    setState({ type, list, isVisible, action });
  };

  const handleClickItem = (item: ItemList, index: number): void => {
    state.action?.(item, index);

    setState({
      ...state,
      isVisible: false,
    });
  };

  const toggleVisibility = (): void => {
    setState((currentState) => ({
      ...currentState,
      isVisible: !currentState.isVisible,
    }));
  };

  return (
    <Styled.Container
      $isVisible={state.isVisible}
      className="xing-vjs-menu-container"
      onClick={toggleVisibility}
      onKeyDown={toggleVisibility}
    >
      <ul className="xing-vjs-menu">
        {state.list.map((item, index) => (
          <Styled.MenuItem $selected={item.selected} key={item.id}>
            <Styled.ItemButton
              type="button"
              onClick={(ev) => {
                ev.stopPropagation();
                handleClickItem(item, index);
              }}
            >
              {item.label}
            </Styled.ItemButton>
          </Styled.MenuItem>
        ))}
      </ul>
    </Styled.Container>
  );
};
